import {
    quiz,
    detailedScore,
    isSimulationMode,
    numberOfQuestions,
    score,
} from "../data/store.js";

import { get } from 'svelte/store';

const WEBHOOK_URL = "https://discord.com/api/webhooks/1252341117807100114/3-jwz7AYVim6pqHHoL8bPmZKArVZ_eWY1AiZACaLHliiC16-83AwnUavOEOesd5I5xAO"

export const getWebhookPayload = () => {
    let payload =  {
        embeds: [
          {
            title: "Quiz result:",
            color: 5814783,
            fields: [
              { name: "Type:", value: get(isSimulationMode) ? "Simulation" : "Classic" },
              { name: "Result:", value: `${get(score)}/${get(numberOfQuestions)}` },
            ],
          },
        ]
      };

    let incorrect = {
        title: "Incorrect answers:",
        color: 5814783,
        fields: [],
    }

    if(get(score) !== get(numberOfQuestions)) {
        let questions = get(detailedScore)
                        .reduce((acc, it, index) => {
                            let question = get(quiz)[index]
                            acc[question.question] = it;
                            acc[question.question].correctAnswer = question.correctAnswer
                            return acc
                        }, {})
        for(let q in questions) {
            if(questions[q].correct) delete questions[q]
        }
        let mistakes = Object.keys(questions).map(q => {return { name: q, value: `❌ Chosen answer: ${questions[q].chosenAnswer}\n✅ Correct answer: ${questions[q].correctAnswer}\n` }})
        incorrect.fields = mistakes;
        payload.embeds.push(incorrect);
    }

    return payload
    
}

export const sendMessageToDiscord = async () => {
    try {
      const response = await fetch(WEBHOOK_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(getWebhookPayload()),
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error status: ${response.status}`);
      }
  
      console.log('Message sent successfully.');
    } catch (error) {
      console.error('Failed to send message:', error);
    }
  }
  